module.exports = __webpack_public_path__ + "img/41.eb19f2f8.png";